import { type ErrorLike } from "@apollo/client";
import { CombinedGraphQLErrors } from "@apollo/client/errors";

/** Returns the distinct messages represented by an Apollo or standard error. */
export function getErrorMessages(error: ErrorLike): string[] {
  if (!CombinedGraphQLErrors.is(error)) {
    return [error.message];
  }

  if (error.errors.length === 0) {
    return [error.message];
  }

  // Remove duplicate error messages - It is possible the backend sent the same error message multiple times.
  return error.errors.map((error) => error.message).unique();
}

/** Builds an error for a missing entity. I.e. `p:123 was not found`. */
export function entityNotFoundError(id: string) {
  return global.Error(`${id} was not found`);
}
